import { atom } from 'jotai';

export const isConversationScrolledToTopState = atom<boolean>(true);

export const isConversationScrolledToBottomState = atom<boolean>(true);
